import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { InternalModule } from '../internal/internal.module';
import { MaterialModule } from '../material/material.module';
import { OwnerDashboardModule } from '../owner-dashboard/owner-dashboard.module';
import { SettlementStatementModule } from '../settlement-statement/settlement-statement.module';
import { LoadApprovalModule } from '../shared/load-approval-dialog/load-approval.module';
import { SharedModule } from '../shared/shared.module';
import { TypeBadgePipe } from '../shared/type-badge.pipe';
import { BillingComponent } from './billing/billing.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FinancialsComponent } from './financials/financials.component';
import { LohiDashboardRoutingModule } from './lohi-dashboard-routing.module';
import { LohiDashboardComponent } from './lohi-dashboard.component';
import { MapComponent } from './map/map.component';
import { CarrierPerformanceLostRevenueComponent } from './performance/carrier-performance-lost-revenue/carrier-performance-lost-revenue.component';
import { PerformanceComponent } from './performance/performance.component';
import { RegionalNewsComponent } from './regional-news/regional-news.component';
import { SettlementComponent } from './settlements/settlement.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { UpdateMonthlyCostsModalComponent } from './update-costs-modal/update-costs-modal.component';

@NgModule({
  declarations: [
    LohiDashboardComponent,
    DashboardComponent,
    PerformanceComponent,
    SidebarComponent,
    MapComponent,
    CarrierPerformanceLostRevenueComponent,
    UpdateMonthlyCostsModalComponent,
    TypeBadgePipe,
    BillingComponent,
    FinancialsComponent,
    RegionalNewsComponent,
    SettlementComponent,
  ],
  imports: [
    CommonModule,
    LoadApprovalModule,
    MatSelectModule,
    MatButtonModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    MatTabsModule,
    MatDialogModule,
    MatInputModule,
    MatFormFieldModule,
    LohiDashboardRoutingModule,
    RouterModule,
    InternalModule,
    SharedModule,
    MatIconModule,
    MatTooltipModule,
    SettlementStatementModule,
    OwnerDashboardModule,
    MatExpansionModule,
  ],
  providers: [DatePipe],
})
export class Dashboard2025Module {}
